module.exports = __webpack_public_path__ + "static/media/inactive-bottom-shield.e005080d.svg";